





















































































import { getUserData } from "@/auth/getUserData";
import useParseMessage from "@/composables/v2.1/useParseMessage";
import useChatInput from "@/composables/v3/useChatInput";
import useTemplates from "@/composables/v3/useTemplates";
import { ParseMessagesInterface } from "@/interfaces/parseMessages.interface";
import ToastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
import axios from "@/libs/axios";
// @ts-ignore
import i18n from "@/libs/i18n";
import { useChannelsStore } from "@/store/useChannelsStore";
import { useChatsStore } from "@/store/useChatsStore";
import { useContactsStore } from "@/store/useContactsStore";
import { useQuickRepliesStore } from "@/store/useQuickRepliesStore";
import { AbilityPossessionType } from "@/types/abilityPossession.type";
import { RequestQueryBuilder } from "@rewiko/crud-request";
import { computed, defineComponent, ref } from "@vue/composition-api";
import { useUploadAttachmentsStore } from "@/store/useUploadAttachmentsStore";

import { BBadge, BButton, BCardText, BDropdownItemButton, BListGroup, BListGroupItem, BOverlay } from "bootstrap-vue";
import { useToast } from "vue-toastification/composition";
import ManageQuickReply from "./manageQuickReply.vue";

export default defineComponent({
    components: {
        BButton,
        BDropdownItemButton,
        BBadge,
        BListGroup,
        BListGroupItem,
        BCardText,
        BOverlay,
        ManageQuickReply,
    },
    setup(_, context) {
        const toast = useToast();
        const chatsStore = useChatsStore();
        const channelsStore = useChannelsStore();
        const contactsStore = useContactsStore();
        const quickRepliesStore = useQuickRepliesStore();

        const { parseMessage } = useParseMessage();

        const isManageQuickReplyPanelActive = ref(false);

        const {
            replaceVariablesByObject,
            mapVariablesValues,
            fetchVariablesFromContent,
            isQuickReply,
            activeChatTemplatesTab,
        } = useTemplates();

        quickRepliesStore.fetchQuickReplies(
            RequestQueryBuilder.create({
                join: { field: "channels", select: ["id"] },
                fields: ["title", "content", "private", "userId", "assetId"],
                filter: [{ field: "channels.id", operator: "$eq", value: channelsStore.activeChatChannel?.id }],
            })
        );

        const blankQuickReply = {
            channels: [],
            private: 0,
            title: "",
            content: "",
        };
        const quickReply = ref(JSON.parse(JSON.stringify(blankQuickReply)));
        const manageQuickReply = (quickReplyData) => {
            quickReply.value = quickReplyData;
            isManageQuickReplyPanelActive.value = true;
        };
        const closeManageQuickReplyPanel = () => {
            quickReply.value = JSON.parse(JSON.stringify(blankQuickReply));
            isManageQuickReplyPanelActive.value = false;
        };
        const createQuickReply = (quickReply) => {
            axios
                .post(`/quick-replies`, quickReply)
                .then(() => {
                    quickRepliesStore.fetchQuickReplies(
                        RequestQueryBuilder.create({
                            join: { field: "channels", select: ["id"] },
                            fields: ["title", "content", "private", "userId", "assetId"],
                            filter: [
                                { field: "channels.id", operator: "$eq", value: channelsStore.activeChatChannel?.id },
                            ],
                        })
                    );
                    closeManageQuickReplyPanel();

                    toast({
                        component: ToastificationContent,
                        props: {
                            title: i18n.t("entities.quick-replies.Quick replies"),
                            text: i18n.t("entities.quick-replies.create-success"),
                            icon: "check",
                            variant: "success",
                        },
                    });
                })
                .catch(() =>
                    toast({
                        component: ToastificationContent,
                        props: {
                            title: i18n.t("entities.quick-replies.Quick replies"),
                            text: i18n.t("entities.quick-replies.create-error"),
                            icon: "times",
                            variant: "danger",
                        },
                    })
                );
        };
        const updateQuickReply = (quickReply) => {
            axios
                .patch(`/quick-replies/${quickReply.id}`, quickReply, { params: { fields: "id" } })
                .then(() => {
                    quickRepliesStore.fetchQuickReplies(
                        RequestQueryBuilder.create({
                            join: { field: "channels", select: ["id"] },
                            fields: ["title", "content", "private", "userId", "assetId"],
                            filter: [
                                { field: "channels.id", operator: "$eq", value: channelsStore.activeChatChannel?.id },
                            ],
                        })
                    );

                    closeManageQuickReplyPanel();

                    toast({
                        component: ToastificationContent,
                        props: {
                            title: i18n.t("entities.quick-replies.Quick replies"),
                            text: i18n.t("entities.quick-replies.update-success"),
                            icon: "check",
                            variant: "success",
                        },
                    });
                })
                .catch(() =>
                    toast({
                        component: ToastificationContent,
                        props: {
                            title: i18n.t("entities.quick-replies.Quick replies"),
                            text: i18n.t("entities.quick-replies.update-error"),
                            icon: "times",
                            variant: "danger",
                        },
                    })
                );
        };

        const deleteQuickReply = (quickReply) => {
            context.root.$bvModal
                .msgBoxConfirm(i18n.t("confirm.Are you sure?"), {
                    title: i18n.t("confirm.Are you sure?"),
                    cancelTitle: i18n.t("confirm.Cancel"),
                    cancelVariant: "light",
                    okTitle: i18n.t("confirm.Yes, delete"),
                    hideHeaderClose: false,
                    headerCloseVariant: "light",
                    centered: true,
                })
                .then((result) => {
                    if (result) {
                        return axios
                            .delete(`/quick-replies/${quickReply.id}`)
                            .then(() => {
                                quickRepliesStore.fetchQuickReplies(
                                    RequestQueryBuilder.create({
                                        join: { field: "channels", select: ["id"] },
                                        fields: ["title", "content", "private", "userId", "assetId"],
                                        filter: [
                                            {
                                                field: "channels.id",
                                                operator: "$eq",
                                                value: channelsStore.activeChatChannel?.id,
                                            },
                                        ],
                                    })
                                );
                                toast({
                                    component: ToastificationContent,
                                    props: {
                                        title: i18n.t("alert.delete.success.title"),
                                        icon: "check",
                                        variant: "success",
                                    },
                                });
                            })
                            .catch(() => {
                                toast({
                                    component: ToastificationContent,
                                    props: {
                                        title: i18n.t("alert.delete.error.title"),
                                        icon: "times",
                                        variant: "danger",
                                    },
                                });
                            });
                    }
                });
        };

        const setQuickReply = async (quickReply) => {
            quickRepliesStore.isLoadingQuickReplies = true;

            const quickReplyString = await parseMessage({
                inputMessage: quickReply.content as string,
                parseData: {
                    contact: contactsStore.activeChatContact?.id as number,
                    assignedAgent: chatsStore.activeChat?.chat.assignedUserId as number,
                    sendingAgent: getUserData(),
                },
            } as ParseMessagesInterface).then((result) => result.parsedMessage);

            quickRepliesStore.isLoadingQuickReplies = false;

            const { message } = useChatInput();
            message.value = quickReplyString;

            isQuickReply.value = true;
            activeChatTemplatesTab.value = "";

            const { clearAttachments, fetchAsset } = useUploadAttachmentsStore();
            clearAttachments();

            if (quickReply.assetId) {
                fetchAsset(quickReply.assetId);
            }
        };

        const canModify = (quickReply, action) => {
            const userData = getUserData();

            const quickReplyAbility = userData.ability.find((ability) => ability.subject === "quickReplies");

            if (quickReplyAbility?.possession.includes(`${action}:any` as AbilityPossessionType)) {
                return true;
            }

            if (quickReplyAbility?.possession.includes(`${action}:own` as AbilityPossessionType)) {
                return userData.id === quickReply.userId;
            }

            return false;
        };

        const { templateSearchString } = useTemplates();
        const quickReplies = computed(() => {
            return quickRepliesStore.quickReplies.filter((template) =>
                //lodash.startsWith(template.title.toLowerCase(), templateSearchString.value.toLowerCase())
                template.title.toLowerCase().includes(templateSearchString.value.toLowerCase())
            );
        });

        return {
            quickReplies,
            quickRepliesStore,
            isManageQuickReplyPanelActive,
            quickReply,

            canModify,
            manageQuickReply,
            closeManageQuickReplyPanel,
            createQuickReply,
            updateQuickReply,
            deleteQuickReply,
            setQuickReply,
            replaceVariablesByObject,
            mapVariablesValues,
            fetchVariablesFromContent,
            getUserData,
        };
    },
});
